import React, { useCallback, useEffect, useRef, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { DatePicker, Badge, Card, Select, Button, Tag } from "antd";
import moment from "moment";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { socket } from "../../socket";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import orderaudio from "./order.mp3";
import printaudio from "./printing.mp3";
import { updateFilter } from "../../store/features/Filters/orderSlice";

const Orders = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const orderFilterDetails = useSelector((state) => state.odderFilter.list);
  const { Meta } = Card;
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [pageDetails, setPageDetails] = useState([]);
  const [shopesList, setShopsList] = useState([]);
  const [update, setUpdate] = useState();

  let roldeId = localStorage.getItem("items");
  var bytes = CryptoJS.AES.decrypt(
    roldeId || 1,
    "J8Lw2Be[CdBZhf/!3?}973Z5O'uNtY4N",
  );
  var originalText = bytes.toString(CryptoJS.enc.Utf8);
  const dateFormat = "YYYY/MM/DD";

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef();
  const PAGE_SIZE = 10;

  // Last item reference
  const lastItemRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore],
  );

  useEffect(() => {
    setHasMore(true);
    setPageDetails([]);
    getPageDetails(1);
    setPage(1);
  }, [
    orderFilterDetails.order,
    orderFilterDetails.shop,
    orderFilterDetails.status,
    orderFilterDetails.date,
    update,
    orderFilterDetails.deliveryType,
    orderFilterDetails.platform,
    orderFilterDetails.gstOrderId,
    orderFilterDetails.paymentId,
    orderFilterDetails.consumerNumber,
  ]);

  useEffect(() => {
    if (page > 1) {
      getPageDetails(page);
    }
  }, [page]);

  useEffect(() => {
    try {
      (async () => {
        const shopDetails = await axios.get("/all-shops").catch((error) => {
          Helper.ErrorHanlder(error);
        });
        if (shopDetails && shopDetails.data) {
          setShopsList(shopDetails.data.data);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, []);

  useEffect(() => {
    try {
      socket.on("new_order", (val) => {
        if (val) {
          setUpdate(Date.now());
          if (originalText && originalText == 2) {
            var audio = new Audio(orderaudio);
            audio.play();
          }
        }
      });
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, [originalText]);

  useEffect(() => {
    try {
      socket.on("new_order_print", (val) => {
        if (val) {
          if (originalText && originalText == 4) {
            var audio = new Audio(printaudio);
            audio.play();
          }
          setUpdate(Date.now());
        }
      });
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, [originalText]);

  const getPageDetails = async (pageNo = 1) => {
    try {
      (async () => {
        setLoading(true);
        const data = await axios
          .get("/order-list", {
            params: {
              role: originalText,
              order: orderFilterDetails.order,
              status: orderFilterDetails.status,
              date: orderFilterDetails.date,
              shop: orderFilterDetails.shop,
              platform: orderFilterDetails.platform,
              deliveryType: orderFilterDetails.deliveryType,
              gstOrderId: orderFilterDetails.gstOrderId,
              paymentId: orderFilterDetails.paymentId,
              consumerNumber: orderFilterDetails.consumerNumber,
              page: pageNo,
              limit: PAGE_SIZE,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) {
          pageNo == 1
            ? setPageDetails(data.data.data)
            : setPageDetails((prev) => [...prev, ...data.data.data]);
          if (data.data.data.length < PAGE_SIZE) {
            setHasMore(false);
          }

          setLoading(false);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  function onSelectDate(date, dateString) {
    if (dateString[0]) {
      dispatch(updateFilter({ date: dateString }));
    } else {
      dispatch(updateFilter({ date: "" }));
    }
  }

  return (
    <Container fluid>
      <div className="order-pg">
        <Row>
          {originalText == 3 || originalText == 1 ? (
            <Col md={12}>
              <div className="new-order-btn">
                <Button
                  type="primary"
                  ghost
                  onClick={(e) => {
                    navigate("/create-order");
                  }}
                >
                  New Order
                </Button>
              </div>
            </Col>
          ) : (
            ""
          )}
          <Col lg={12}>
            <div className="order-pg-cards">
              {originalText == 1 || originalText == 3 ? (
                <div className="input-group search">
                  <Select
                    defaultValue="All"
                    allowClear
                    style={{ width: "96%", height: "100%" }}
                    onChange={(input) =>
                      dispatch(updateFilter({ status: input }))
                    }
                    value={orderFilterDetails.status}
                    options={[
                      { value: "", label: "All" },
                      { value: "pending", label: "Pending" },
                      { value: "in-progress", label: "In progress" },
                      { value: "dispatched", label: "Dispatched" },
                      { value: "shipped", label: "Shipped" },
                      { value: "cancelled", label: "Cancelled" },
                    ]}
                  />
                </div>
              ) : (
                ""
              )}
              <div className="input-group search">
                <input
                  type="text"
                  className="form-control search-input-box"
                  placeholder="Search by order"
                  value={orderFilterDetails.order}
                  onChange={(e) => {
                    dispatch(updateFilter({ order: e.target.value }));
                  }}
                />
                <FontAwesomeIcon
                  className="search-fn"
                  icon={faMagnifyingGlass}
                />
              </div>
              <div className="input-group search">
                <Select
                  defaultValue="All"
                  allowClear
                  style={{ width: "96%", height: "100%" }}
                  onChange={(input) =>
                    dispatch(updateFilter({ deliveryType: input }))
                  }
                  value={orderFilterDetails.deliveryType}
                  options={[
                    { value: "", label: "All" },
                    { value: "onhand", label: "On Hand" },
                    { value: "courier", label: "Courier" },
                  ]}
                />
              </div>
              {originalText != 3 && (
                <div className="input-group search">
                  <Select
                    showSearch
                    allowClear
                    defaultValue="All"
                    style={{ width: "96%", height: "100%" }}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={orderFilterDetails.shop}
                    onChange={(input) =>
                      dispatch(updateFilter({ shop: input }))
                    }
                  >
                    <Option key={0} value={""}>
                      Select
                    </Option>
                    {shopesList.map((i) => (
                      <Option key={i.id} value={i.id}>
                        {i.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}
              {originalText == 1 || originalText == 3 ? (
                <div className="input-group search">
                  <Select
                    defaultValue="All"
                    allowClear
                    style={{ width: "95%", height: "100%" }}
                    onChange={(input) =>
                      dispatch(updateFilter({ platform: input }))
                    }
                    value={orderFilterDetails.platform}
                    options={[
                      { value: "", label: "All" },
                      { value: "web", label: "WebSite" },
                    ]}
                  />
                </div>
              ) : (
                ""
              )}
              {originalText == 1 || originalText == 3 ? (
                <div className="input-group search">
                  <RangePicker
                    onChange={onSelectDate}
                    style={{ width: "100%", height: "100%" }}
                    defaultValue={
                      orderFilterDetails.date && [
                        dayjs(orderFilterDetails.date[0], dateFormat),
                        dayjs(orderFilterDetails.date[1], dateFormat),
                      ]
                    }
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col lg={10} style={{ marginTop: "10px" }}>
            <div className="order-pg-cards">
              <div className="input-group search">
                <input
                  type="text"
                  className="form-control search-input-box"
                  placeholder="Search by GST Order ID"
                  value={orderFilterDetails.gstOrderId}
                  onChange={(e) => {
                    dispatch(updateFilter({ gstOrderId: e.target.value }));
                  }}
                />
                <FontAwesomeIcon
                  className="search-fn"
                  icon={faMagnifyingGlass}
                />
              </div>
              <div className="input-group search">
                <input
                  type="text"
                  className="form-control search-input-box"
                  placeholder="Search by Payment ID"
                  value={orderFilterDetails.paymentId}
                  onChange={(e) => {
                    dispatch(updateFilter({ paymentId: e.target.value }));
                  }}
                />
                <FontAwesomeIcon
                  className="search-fn"
                  icon={faMagnifyingGlass}
                />
              </div>
              <div className="input-group search">
                <input
                  type="text"
                  className="form-control search-input-box"
                  placeholder="Search by Consumer Number"
                  value={orderFilterDetails.consumerNumber}
                  onChange={(e) => {
                    dispatch(updateFilter({ consumerNumber: e.target.value }));
                  }}
                />
                <FontAwesomeIcon
                  className="search-fn"
                  icon={faMagnifyingGlass}
                />
              </div>
            </div>
          </Col>
          <Col lg={12} className="orders-list">
            <div className="orders">
              {pageDetails.map((val) => (
                <Col
                  lg={4}
                  className="order-items"
                  ref={lastItemRef}
                  key={val.id}
                >
                  <Badge.Ribbon text={val.status}>
                    <Card
                      onClick={(e) => {
                        navigate(`/orderdetails/${val.id}`);
                      }}
                    >
                      <Meta title={`Order ID : #${val.orderId}`} />
                      <div className="oder-details">
                        <p>
                          <label>
                            {val.Shop.name}
                            <Tag
                              color={
                                val?.address &&
                                Object.keys(val.address).length > 0
                                  ? "red"
                                  : "green"
                              }
                              className="ms-3"
                            >
                              {val?.address &&
                              Object.keys(val.address).length > 0
                                ? "Courier"
                                : "On Hand"}
                            </Tag>
                          </label>
                        </p>
                        <p>
                          <label>Product :</label> {val.Category.name}
                        </p>
                        {val.attributesDetails.map((obj) => (
                          <p>
                            <label>
                              {obj.Variant.name} : {obj.name}
                            </label>
                          </p>
                        ))}
                        <p>
                          <label>Qunatity :</label> {val.quantity}
                        </p>
                      </div>
                      <p className="order-at">
                        {moment(val.createdAt).format("DD-MM-YYYY hh:mm:ss A")}
                      </p>
                    </Card>
                  </Badge.Ribbon>
                </Col>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Orders;
